<template>
  <div>
    <panel
      Title="افزودن پرسش و پاسخ متداول"
      Des="از طریق این فرم می‌توانید پرسش و پاسخ جدید اضافه کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-card>
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-plus-circle ml-2"></i>فرم ایجاد پرسش و پاسخ
            </h6>
          </template>
          <template slot="content">
            <div class="row">
              <div class="col-12 text-right mt-3">
                <small>سوال</small>
                <textarea
                  class="form-control mt-2"
                  rows="3"
                  placeholder="سوال را وارد کنید..."
                  v-model="question"
                ></textarea>
              </div>
              <div class="col-12 text-right mt-3">
                <small>پاسخ</small>
                <textarea
                  class="form-control mt-2"
                  rows="5"
                  placeholder="پاسخ را وارد کنید..."
                  v-model="answer"
                ></textarea>
              </div>
              <div class="col-12 text-right mt-4">
                <button
                  class="btn btn-success w-100"
                  @click="createFAQ"
                  :disabled="!question || !answer || isSubmitting"
                >
                  <span v-if="isSubmitting">در حال ثبت...</span>
                  <span v-else>ثبت</span>
                </button>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
  </div>
</template>

<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'

export default {
  components: {
    Panel,
    NetPaCard,
  },
  data() {
    return {
      question: '',
      answer: '',
      isSubmitting: false,
      DataAxiosCreateFAQ: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'FAQ/Create',
        Token: this.$session.get('TokenNetPa'),
      },
    }
  },
  methods: {
    createFAQ() {
      if (!this.question || !this.question.trim()) {
        this.$mySweetDefaultTost('خطا', 'لطفا سوال را وارد کنید', 'warning', 2000)
        return
      }
      
      if (!this.answer || !this.answer.trim()) {
        this.$mySweetDefaultTost('خطا', 'لطفا پاسخ را وارد کنید', 'warning', 2000)
        return
      }

      this.isSubmitting = true

      const formData = new FormData()
      const userInfoNetPa = this.$session.get('UserInfoNetPa')
      const azaId = userInfoNetPa ? userInfoNetPa.wwwtblAzaId : null
      
      if (!azaId) {
        this.$mySweetDefaultTost('خطا', 'اطلاعات کاربر یافت نشد', 'error', 2000)
        this.isSubmitting = false
        return
      }
      
      formData.append('azaId', azaId)
      formData.append('question', this.question.trim())
      formData.append('answer', this.answer.trim())

      this.DataAxiosCreateFAQ.ArryfildValue = formData

      this.$PostFormData(this.DataAxiosCreateFAQ)
        .then((data) => {
          if (data.status === 'Ok' || data.success === true) {
            this.$mySweetDefault('عملیات موفق', 'پرسش و پاسخ با موفقیت ثبت شد', 'success', 2000)
            this.$router.push({ name: 'FAQManagement' })
          } else {
            this.$mySweetDefaultTost('خطا', 'خطا در ثبت پرسش و پاسخ', 'error', 2000)
          }
        })
        .catch((error) => {
          console.error('Error creating FAQ:', error)
          this.$mySweetDefaultTost('خطا', 'خطا در ثبت پرسش و پاسخ', 'error', 2000)
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
  },
}
</script>

<style scoped>
</style>

